import { useEffect, useRef, useState } from "react";
import { getApartmentTypeByIds } from "../../helpers/helpers";
import { ApartmentsTypes } from "../../Data/ApartmentsTypes";
import USDIconSVG from "../SVG/USDIconSVG";

const RightSide = ({ selectedProject, apartment, rooms }) => {
  const [selectedMode, setSelectedMode] = useState("3d");

  const iframeContainerRef = useRef(null);
  const [disableScroll, setDisableScroll] = useState(false);

  useEffect(() => {
    if (disableScroll) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [disableScroll]);

  return (
    <>
      {/* Mobile Version */}
      <div className="xl:hidden flex items-center justify-between col-span-full col-start-1 row-span-2 row-start-1 gap-2 border-y-2 border-primary-dark/30 text-primary-bg-blue text-lg">
        <div className=" w-full flex items-center justify-between">
          <p
            className={`w-1/3 text-lg text-primary-bg-blue py-4 flex items-center justify-center gap-2`}
          >
            <span className="tracking-normal">
              Ap.{" "}
              <strong className="tracking-wider ">{apartment.number}</strong>
            </span>
          </p>
          <p
            className={`h-full w-1/3 flex items-center justify-center relative group tracking-wider border-x-2 border-primary-dark/30`}
          >
            {
              getApartmentTypeByIds(
                apartment.typeId,
                apartment.subTypeId,
                ApartmentsTypes,
                selectedProject
              ).apartmentSubTypeObject.size
            }{" "}
            <span data-v-418ea57b="">
              m<sup data-v-418ea57b="">2</sup>
            </span>
          </p>
          <p
            className={`h-full w-1/3 flex items-center justify-center relative group tracking-wider`}
          >
            {Number(
              (apartment.subType.size * selectedProject.price).toFixed(0)
            ).toLocaleString()}
            <span className="uppercase ml-1">
              {" "}
              {selectedProject.currecy === "usd" ? (
                <USDIconSVG w={16} h={16} />
              ) : null}
            </span>
          </p>
        </div>
      </div>

      {/* Desktop Version */}
      <div className="hidden border-y-2 border-l-2 border-primary-dark/30 xl:col-span-8 xl:col-start-5 row-span-2 row-start-1 xl:flex items-center justify-between gap-8 text-primary-bg-blue text-2xl pl-8">
        <div className="flex items-center justify-start">
          <p
            className={`h-full flex items-center justify-center relative group tracking-wider border-r-2 border-primary-dark/30 pr-16`}
          >
            {
              getApartmentTypeByIds(
                apartment.typeId,
                apartment.subTypeId,
                ApartmentsTypes,
                selectedProject
              ).apartmentSubTypeObject.size
            }{" "}
            <span data-v-418ea57b="">
              m<sup data-v-418ea57b="">2</sup>
            </span>
          </p>
          <p
            className={`h-full flex items-center justify-center relative group tracking-wider pl-4`}
          >
            {Number(
              (apartment.subType.size * selectedProject.price).toFixed(0)
            ).toLocaleString()}
            <span className="uppercase ml-2">
              {"  "}
              {selectedProject.currecy}
            </span>
          </p>
        </div>
        <div className="h-full flex items-center justify-between">
          <div
            className={`h-full uppercase flex items-center justify-center pr-4 cursor-pointer`}
            onClick={() => setSelectedMode("3d")}
          >
            <p
              className={`${
                selectedMode === "3d"
                  ? "text-primary-orange"
                  : "text-primary-bg-blue"
              } flex items-center justify-center`}
            >
              3d
            </p>
          </div>
          {/* <div
            className="uppercase flex items-center justify-center px-4 border-l-2 border-l-primary-dark/30 cursor-pointer"
            onClick={() => setSelectedMode("2d")}
          >
            <p
              className={`${
                selectedMode === "2d"
                  ? "text-primary-orange"
                  : "text-primary-bg-blue"
              } flex items-center justify-center`}
            >
              2d
            </p>
          </div> */}
          <div
            className="uppercase flex items-center justify-center border-l-2 border-l-primary-dark/30 pl-4 cursor-pointer"
            onClick={() => setSelectedMode("360")}
          >
            <p
              className={`${
                selectedMode === "360"
                  ? "text-primary-orange"
                  : "text-primary-bg-blue"
              } flex items-center justify-center`}
            >
              360 <sup className="text-sm">o</sup>
            </p>
          </div>
        </div>
      </div>
      {/* Image Section */}
      <div className="xl:border-l-2 border-primary-dark/30 col-span-full xl:col-span-8 xl:col-start-5 row-span-10 row-start-3 flex flex-col items-center justify-center py-4 xl:px-8 text-primary-bg-blue text-xl">
        {selectedMode === "3d" && (
          <img
            src={apartment.subType.renders[0]}
            alt=""
            className="h-auto w-full object-fill transition-all animate-fadeIn"
          />
        )}
        {selectedMode === "360" &&
          (apartment?.subType?.image360?.length > 0 ||
            apartment?.subType?.imageOffice?.length > 0) && (
            <div
              ref={iframeContainerRef}
              className="relative h-96 xl:h-full w-full overflow-hidden"
              onMouseEnter={() => setDisableScroll(true)}
              onMouseLeave={() => setDisableScroll(false)}
            >
              {/* Transparent overlay to catch mouse events */}

              <iframe
                title={`${apartment.number} 360 view`}
                className="h-96 xl:h-full w-full object-cover object-center transition-all animate-fadeIn"
                src={
                  apartment.floorNumber === 2 && apartment.number === 1
                    ? apartment.subType.imageOffice
                    : apartment.subType.image360
                }
              ></iframe>
            </div>
          )}
      </div>
      {/* Mobile Version Image type Selector */}
      <div className="xl:hidden flex items-center justify-between col-span-full col-start-1 px-16 py-8 border-b-2 border-primary-dark/30">
        <div
          className={`uppercase flex items-center justify-center pr-4 cursor-pointer`}
          onClick={() => setSelectedMode("3d")}
        >
          <p
            className={`${
              selectedMode === "3d"
                ? "text-primary-orange"
                : "text-primary-bg-blue"
            } flex items-center justify-center`}
          >
            3d
          </p>
        </div>

        <div
          className="uppercase flex items-center justify-center border-l-2 border-l-primary-dark/30 pl-4 cursor-pointer"
          onClick={() => setSelectedMode("360")}
        >
          <p
            className={`${
              selectedMode === "360"
                ? "text-primary-orange"
                : "text-primary-bg-blue"
            } flex items-center justify-center`}
          >
            360 <sup className="text-sm">o</sup>
          </p>
        </div>
      </div>
      <div className="xl:hidden w-full flex flex-col items-start justify-between gap-4 text-primary-dark py-8">
        <span className="text-xl">
          სართული <strong>{apartment.floorNumber}</strong>
        </span>
        <div className="flex flex-col items-start justify-between gap-2">
          <span>
            ჩაბარების პირობა:{" "}
            <strong className="text-primary-orange tracking-wider">
              {selectedProject.name === "nikea"? "მწვანე კარკასი": "თეთრი კარკასი"}
            </strong>
          </span>
        </div>
      </div>
      <ul className="xl:hidden text-primary-bg-blue col-span-1 py-4">
        {rooms &&
          rooms.length > 0 &&
          rooms.map((room, index) => {
            return (
              <div key={index} className={`w-full  grid grid-cols-10`}>
                <div
                  className={`col-span-1 flex items-center justify-center col-start-1  bg-primary-orange text-primary-light py-3 text-lg font-semibold ${
                    index === 0
                      ? "rounded-t-full"
                      : index === rooms.length - 1
                      ? "rounded-b-full"
                      : ""
                  }`}
                >
                  {index + 1}
                </div>
                <div
                  className={`col-span-8 flex items-center justify-start col-start-3 text-xl`}
                >
                  <span>{room.label}</span>/
                  <strong>
                    {room.size}m<sup data-v-418ea57b="">2</sup>
                  </strong>
                </div>
              </div>
            );
          })}
      </ul>
    </>
  );
};

export default RightSide;

/* {apartmentsList.map((apartment) => {

  return (
    <React.Fragment key={apartment.number}>
      
      <div
        
        className={`xl:hidden w-full grid grid-cols-2 md:grid-cols-6 my-4 text-sm md:text-2xl md:my-8 ${
          apartment.isSold
            ? "cursor-not-allowed text-primary-orange"
            : "hover:bg-primary-dark/5 transition-all duration-200 ease-linear cursor-pointer"
        }`}
        onClick={() => {
          if (!apartment.isSold) {
            navigate(`${location.pathname}/${apartment.number}`);
          }
        }}
      >
        <span className="md:hidden h-full  py-2 border-b-2 border-r-2 border-primary-dark/30 col-span-1 flex flex-col gap-2">
          <span>{apartment.number}</span>
          <span>{apartment.size} კვ.მ</span>
        </span>
        <span className="md:hidden h-full pl-2 py-2 border-b-2 border-primary-dark/30 col-span-1 flex flex-col gap-2">
          <span>სართული {apartment.floor}</span>
          <span>{apartment.typelabel}</span>
        </span>

        <span className="hidden md:block xl:hidden h-full pr-2 py-5 border-b-2 border-r-2 border-primary-dark/30 col-span-1 ">
          {apartment.number}
        </span>
        <span className="hidden md:block xl:hidden h-full px-2 py-5 border-b-2 border-r-2 border-primary-dark/30 col-span-2 ">
          {apartment.typelabel}
        </span>
        <span className="hidden md:block xl:hidden h-full px-2 py-5 border-b-2 border-r-2 border-primary-dark/30 col-span-1 ">
          სართული {apartment.floor}
        </span>
        <span className="hidden md:block xl:hidden h-full px-2 py-5 border-b-2 border-r-2 border-primary-dark/30 col-span-1 ">
          {apartment.size} კვ.მ
        </span>
        <span className="hidden md:block xl:hidden h-full px-2 py-5 border-b-2 border-primary-dark/30 col-span-1 ">
          ფასი
        </span>
        <span className="h-full pr-2 py-5 col-span-full flex items-center justify-center">
          <img
            src={apartment.typeImg}
            alt="K2 Invest Green Home"
            className="w-full h-full object-cover object-center"
          />
        </span>
        <span
          className="h-full pr-2 py-2 border-b-2 border-primary-dark col-span-full max-w-fit flex items-center justify-start text-sm md:text-xl uppercase"
          onClick={() => {
            if (!apartment.isSold) {
              navigate(`${location.pathname}/${apartment.number}`);
            }
          }}
        >
          view apartment
        </span>
      </div>
    
      <div
        
        className={`hidden w-full xl:grid grid-cols-12 border-b-2 border-primary-dark/30 ${
          apartment.isSold
            ? "cursor-not-allowed"
            : "hover:bg-primary-dark/5 transition-all duration-200 ease-linear cursor-pointer"
        }`}
        onClick={() => {
          if (!apartment.isSold) {
            navigate(`${location.pathname}/${apartment.number}`);
          }
        }}
      >
        <span className="h-full pr-2 py-5 border-r-2 border-primary-dark/30 col-span-1">
          {apartment.number}
        </span>
        <span className="h-full px-2 py-5 border-r-2 border-primary-dark/30 col-span-2">
          {apartment.typelabel}
        </span>
        <span className="h-full px-2 py-5 border-r-2 border-primary-dark/30 col-span-2">
          სართული {apartment.floor}
        </span>
        <span className="h-full px-2 py-5 border-r-2 border-primary-dark/30 col-span-2">
          {apartment.size} კვ.მ
        </span>
        <span className="h-full px-2 py-5 border-r-2 border-primary-dark/30 col-span-2">
          ფასი
        </span>
        <span
          className={`h-full px-2 py-5 col-span-3 ${
            apartment.isSold ? "text-primary-orange" : ""
          }`}
        >
          {apartment.isSold ? "გაყიდული" : "თავისუფალი"}
        </span>
      </div>
    </React.Fragment>
  );
})} */
